export const TIME_OF_DAY_VALUES = ['morning', 'afternoon', 'evening'] as const;
export type TimeOfDayValue = (typeof TIME_OF_DAY_VALUES)[number];

export function isTimeOfDayValue(value: string): value is TimeOfDayValue {
  return TIME_OF_DAY_VALUES.includes(value as TimeOfDayValue);
}

export interface TimeRange {
  from: string;
  to: string;
}
